import Court from "./Court";
import Bola from "./Bola";
import Placar from "./Placar";
import BasicReports from "./basicReports";
const Gym = ({
  visitorNumbers,
  homeNumbers,
  tiimeSacador,
  placar,
  sette,
  times,
  positionHome,
  homeLeft,
  numScout,
  partida,
  numSet,
  teamNames,
}) => {
  const bolaPosition = homeLeft
    ? tiimeSacador === "a"
      ? "top-right"
      : "bottom-left"
    : tiimeSacador === "a"
    ? "bottom-left"
    : "top-right";

  return (
    <div className="flex flex-col shadow-lg items-center">
      {/* <Placar score={placar} positionHome={homeLeft} /> */}

      <div className="relative  bg-green-600 rounded-lg w-[380px] mt-2">
        <div className="flex justify-center pt-6 items-center w-full">
          <Court
            visitorNumbers={visitorNumbers}
            homeNumbers={homeNumbers}
            setterPosition={sette}
            teams={times}
            positionHome={homeLeft}
          />
        </div>
        {/* Reserva espaço para o botão de setas, mesmo quando não visível */}
        <div
          style={{ height: 40, marginTop: 8 }}
          className="flex justify-center items-center w-full"
        >
          {numScout === 1 ? (
            <button
              onClick={() => positionHome(!homeLeft)}
              className="p-1 rounded-full transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {/* Setinha de cima: Direita */}
                <path d="M3 7h14" />
                <polyline points="14 4 17 7 14 10" />

                {/* Setinha de baixo: Esquerda */}
                <path d="M21 17H7" />
                <polyline points="10 14 7 17 10 20" />
              </svg>
            </button>
          ) : null}
        </div>
        <Bola position={bolaPosition} />
      </div>
      {/* <div className="flex justify-center items-center w-full">
        <BasicReports
          partida={partida}
          numSet={numSet}
          positionHome={homeLeft}
          score={placar}
          teamNames={teamNames}
        />
      </div> */}
    </div>
  );
};

export default Gym;
